import React from 'react';
import { 
  FormControl, 
  Select, 
  MenuItem, 
  SelectChangeEvent,
  InputAdornment,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import sortIcon from '../../../assets/images/knownIssue/sortIcon.svg';
import ascending from '../../../assets/images/knownIssue/ascIcon.svg';
import descending from '../../../assets/images/knownIssue/dscIcon.svg';

interface KnownIssuesSortDropdownProps {
  selectedSort: string;
  onSortChange: (sortValue: string) => void;
  staticContent: {
    sort: string;
  };
}

const KnownIssuesSortDropdown: React.FC<KnownIssuesSortDropdownProps> = ({
  selectedSort,
  onSortChange,
  staticContent
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
  const sortOptions = t('knownIssues.sortOptions', { returnObjects: true }) as Array<{
    value: string;
    label: string;
  }>;


  const handleChange = (event: SelectChangeEvent<string>) => {
    onSortChange(event.target.value);
  };

  return (
    <FormControl variant='standard' sx={{ minWidth: '272px', 
        width: isTablet ? '50%' : { xs: '100%', sm: '272px' },
        '& .MuiInput-underline:before': {
          borderBottomColor: '#C9CACC'
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
          borderBottomColor: '#C9CACC'
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: '#C9CACC'
        }
         }}>
      {/* <InputLabel id="sort-select-label">Sort By</InputLabel> */}
      <Select
        labelId="sort-select-label"
        id="sort-select"
        value={selectedSort}
        label="Sort By"
        onChange={handleChange}
        displayEmpty
        startAdornment={
          <InputAdornment position="start">
            <img src={sortIcon} alt="Sort" style={{ width: '20px', height: '20px' }} />
          </InputAdornment>
        }
        renderValue={(selected) => {
          if (!selected) {
            return (
              <span style={{ fontSize: '16px', fontWeight: 600, color: '#000000', lineHeight: '20px' }}>
                {staticContent.sort}
              </span>
            );
          }
          const selectedOption = sortOptions.find(option => option.value === selected);
          return selectedOption ? selectedOption.label : selected;
        }}
        sx={{
          // height: '40px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C9CACC'
          },
          '& .MuiSelect-icon': {
          color: '#000000',
        }
        }}
      >
        {sortOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}
            aria-selected={selectedSort === option.value}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {option.value.includes('_asc') && (
                <img src={ascending} alt="Ascending" style={{ width: '16px', height: '16px' }} />
              )}
              {option.value.includes('_desc') && (
                <img src={descending} alt="Descending" style={{ width: '16px', height: '16px' }} />
              )}
              {option.label}
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default KnownIssuesSortDropdown;